import { FC } from 'react'
import { Box } from '@chakra-ui/react'

export interface ModalConfirmationProps {
  text: string
}

const ModalConfirmation: FC<ModalConfirmationProps> = ({ text }) => {
  return (
    <Box h="100%" w="100%">
      <Box pb={10} px={5} textAlign="center" w="100%">
        {text}
      </Box>
    </Box>
  )
}

export default ModalConfirmation
